import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const AssistantMessageWrapper = styled.div`
  align-self: flex-start;
  max-width: 70%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
`

export const AssistantAvatar = styled.div`
  flex-shrink: 0;
  color: ${colors.gray380};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
`

export const AssistantContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

export const AssistantNick = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${colors.gray380};
  padding-left: 4px;
`

export const AssistantBubble = styled.div`
  background: ${colors.gray200};
  color: ${colors.black};
  padding: 10px 14px;
  border-radius: 16px 16px 16px 4px;
  font-size: 16px;
  line-height: 1.5;
  word-break: break-word;
  min-height: 44px;
  min-width: 80px;

  p {
    margin: 0 0 8px;
    white-space: pre-wrap;
  }

  code {
    font-size: 14px;
    font-family: monospace;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    padding: 1px 4px;
  }

  a {
    color: ${colors.gray380};
    text-decoration: underline;
    word-break: break-all;

    &:hover {
      opacity: 0.7;
    }
  }
`

export const RecordsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
  overflow: hidden;
  white-space: nowrap;
`

export const RecordLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 12px;
  border: 1px solid ${colors.gray380};
  color: ${colors.black};
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transform: translateZ(0);
  height: 24px;
  max-width: 100%;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    opacity: 0.6;
  }
`

export const ShowMoreButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  background: transparent;
  border: 1px dashed ${colors.gray380};
  color: ${colors.gray380};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  height: 24px;

  &:hover {
    opacity: 0.6;
  }
`

export const SuggestionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 12px;
  background: transparent;
  border: 1px solid ${colors.gray380};
  color: ${colors.black};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transform: translateZ(0);
  font-family: inherit;
  max-width: 100%;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  svg {
    align-self: start;
  }

  &:hover:not(:disabled) {
    opacity: 0.6;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`

export const DotsLoader = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 2px;
  margin-top: 6px;

  @keyframes dot-bounce {
    0%,
    80%,
    100% {
      transform: scale(0.6);
      opacity: 0.4;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }

  span {
    display: block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${colors.gray380};
    animation: dot-bounce 1.2s infinite ease-in-out;

    &:nth-child(1) {
      animation-delay: -0.32s;
    }

    &:nth-child(2) {
      animation-delay: -0.16s;
    }

    &:nth-child(3) {
      animation-delay: 0s;
    }
  }
`
